/**
 * List endpoints return `token: { id, expires_at } | null` per tradie (aligned with GET /tokens/status).
 * Hydrate component `tokenExpiryDates` without per-row status requests.
 *
 * @param {import('vue').default | { $set: Function, tokenExpiryDates: Record<string | number, string | null> }} vm Component instance
 * @param {Array<{ id: number|string, can_access?: boolean, token?: { expires_at?: string|null } | null }>} tradies
 */
export function tradieHasAssignedToken(tradie) {
  if (!tradie) return false
  if (
    tradie.token &&
    (tradie.token.id != null ||
      (tradie.token.expires_at != null &&
        String(tradie.token.expires_at).trim() !== ''))
  ) {
    return true
  }
  return false
}

export function applyTokenExpiryFromListTradies(vm, tradies) {
  if (!Array.isArray(tradies)) return
  for (const tradie of tradies) {
    if (!tradie) continue
    let expiry = null
    if (
      tradie.token &&
      tradie.token.expires_at != null &&
      String(tradie.token.expires_at).trim() !== ''
    ) {
      expiry = String(tradie.token.expires_at).trim()
    }
    vm.$set(vm.tokenExpiryDates, tradie.id, expiry)
  }
}
